<template>
  <div>
    <div id="header" class="header">
      <div class="header-nav"><!-- 공백 --></div>
      <div class="header-gnb">
        <h1 class="logo">
          <a href="/index.html">
            <img src="../../assets/images/common/ci-wavve.png" alt="wavve" />
          </a>
        </h1>
        <ul class="gnb-left">
          <li><a href="/customer/company.html" id="g-menu">회사소개</a></li>
          <li><a href="/customer/business.html" class="on">사업제휴</a></li>
          <li><a href="/customer/recruit.html">인재채용</a></li>
          <li><a href="/customer/financial_statements.html">투자정보</a></li>
        </ul>
      </div>
    </div>

    <!-- 콘텐츠 영역 -->
    <div id="container" class="container">
      <!-- service -->
      <div class="service">
        <!-- top -->
        <div class="top-contents company-top-contents" id="g-contents">
          <div class="wrap">
            <h1 class="cp-h1">재미의 파도를 타다!<br />콘텐츠웨이브</h1>
          </div>
        </div>
        <!--// top -->

        <!-- sticky nav -->
        <div id="sticky-menu" class="sticky-navigation">
          <ul>
            <li>
              <a href="#i-sec01" v-smooth-scroll="{offset:-64}" class="scroll on">사업제휴</a>
            </li>
            <li>
              <a href="#i-sec02" v-smooth-scroll="{offset:-64}" class="scroll">제휴사소개</a>
            </li>
          </ul>
        </div>
        <!--// sticky nav -->

        <div class="contents-wrap">
          <!-- partner 01 -->
          <div id="i-sec01">
            <div class="partner-sec01 tAc">
              <div class="if-wrap">
                <h2 class="title">사업분야별 제휴문의</h2>
                <ul class="pn-sec01-list">
                  <li>
                    <a href="mailto:partner@captv.co.kr">
                      <i class="line"><!-- 라인 --></i>
                      <strong>제휴</strong>
                      <p>서비스, 디바이스, 쿠폰, 광고, 웨이브온</p>
                      <span class="back-txt">Ser</span>
                    </a>google.png
                  </li>
                  <li>
                    <a href="mailto:partner@captv.co.kr">
                      <i class="line"><!-- 라인 --></i>
                      <strong>콘텐츠 공급</strong>
                      <p>채널 입점, VOD 공급, 홈쇼핑 관련</p>
                      <span class="back-txt">Con</span>
                    </a>
                  </li>
                  <li>
                    <a href="mailto:partner@captv.co.kr">
                      <i class="line"><!-- 라인 --></i>
                      <strong>마케팅</strong>
                      <p>콘텐츠 마케팅, 서비스 홍보, 온라인 마케팅</p>
                      <span class="back-txt">Mar</span>
                    </a>
                  </li>
                  <li>
                    <a href="mailto:partner@captv.co.kr">
                      <i class="line"><!-- 라인 --></i>
                      <strong>리서치</strong>
                      <p>서비스 및 시장 연구조사, 데이터분석, UI/UX</p>
                      <span class="back-txt">Res</span>
                    </a>
                  </li>
                  <li>
                    <a href="mailto:partner@captv.co.kr">
                      <i class="line"><!-- 라인 --></i>
                      <strong>기술제휴 </strong>
                      <p>서비스 기술 연구/개발 분야</p>
                      <span class="back-txt">Tec</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!--// partner 01 -->

          <!-- partner 02 -->
          <div id="i-sec02">
            <div class="partner-sec02 tAc">
              <div class="if-wrap">
                <h2 class="title">제휴사 소개</h2>
                <div class="pn-sec02-list">
                  <img src="../../assets/images/service/p-sec01-img01.png" alt="LG전자"/>
                  <img src="../../assets/images/service/p-sec01-img02.png" alt="SAMSUNG"/>
                  <img src="../../assets/images/service/p-sec01-img03.png" alt="SMR"/>
                  <img src="../../assets/images/service/p-sec01-img04.png" alt="dawin"/>
                  <img src="../../assets/images/service/p-sec01-img05.png" alt="SONOKONG IB"/>
                  <img src="../../assets/images/service/p-sec01-img06.png" alt="(주)더아이앤티"/>
                  <img src="../../assets/images/service/p-sec01-img13.png" alt="구글"/>
                  <img src="../../assets/images/service/p-sec01-img14.png" alt="무비"/>
                  <img src="../../assets/images/service/p-sec01-img15.png" alt="uno+"/>
                  <img src="../../assets/images/service/p-sec01-img16.png" alt="skylife">
                  <img src="../../assets/images/service/p-sec01-img10.png" alt="bugs"/>
                  <img src="../../assets/images/service/p-sec01-img11.png" alt="sk 텔링크"/>
                  <img src="../../assets/images/service/p-sec01-img17.png" alt="sk broadband"/>
                  <img src="../../assets/images/service/p-sec01-img18.png" alt="finnq"/>
                  <img src="../../assets/images/service/p-sec01-img19.png" alt="flo"/>
                </div>
              </div>
            </div>
          </div>
          <!--// partner 02 -->
        </div>

      </div>
      <!--// service -->
    </div>
  </div>
</template>

<script>

import { customerSubMenuScrollEvent } from '@/common/utils/common'
import _ from 'lodash'
export default {
  data () {
    return {
      sticky: false,
      contentElList: [],
      subMenuElList: [],
      subMenuContentElList: [],
      stickyMenuEl: {}
    }
  },
  methods: {
    scrollThrottleEvent: _.throttle(function () {
      customerSubMenuScrollEvent(this.stickyMenuEl, this.contentElList, this.subMenuElList)
    }, 150)
  },
  mounted () {
    this.contentElList = document.querySelectorAll('div[id^=i-sec]')
    this.stickyMenuEl = document.getElementById('sticky-menu')
    this.subMenuElList = document.querySelectorAll('#sticky-menu li a')
    window.addEventListener('scroll', this.scrollThrottleEvent)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.scrollThrottleEvent)
  }
}
</script>
<style lang="css" src="@/assets/css/service.css"></style>
